<template>
    <div>
        <h1>Contact</h1>

        <h4>For questions and comments</h4>
        <p>info@optv.nu</p>

        <h4>For API implementation problems and feature requests</h4>
        <p>support@optv.nu</p>

        <h4>For matters concerning pricing and invoices</h4>
        <p>billing@optv.nu</p>
    </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Contact'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue